import { AppError, ErrorCode } from "../errors.js";
//#region src/sdk/tokens.ts
function createServiceToken(description) {
	return {
		id: Symbol.for(`di.service:${description}`),
		description,
		kind: "service"
	};
}
function createDomainToken(description) {
	return {
		id: Symbol.for(`di.domain:${description}`),
		description,
		kind: "domain"
	};
}
function createServiceTag(description) {
	return {
		id: Symbol.for(`di.service-tag:${description}`),
		description,
		kind: "service-tag"
	};
}
function toRuntimeTokenKey(token) {
	if (typeof token === "string" || typeof token === "symbol") return token;
	if (token && typeof token === "object" && "id" in token) return token.id;
	throw new AppError({
		code: ErrorCode.DI_MISSING_DEPENDENCY,
		message: "Invalid token key."
	});
}
function formatTokenLabel(token) {
	if (typeof token === "string") return token;
	if (typeof token === "symbol") return token.description ?? token.toString();
	return token.description;
}
function toRuntimeServiceTagKey(tag) {
	if (!tag || typeof tag !== "object" || tag.kind !== "service-tag" || typeof tag.id !== "symbol") throw new AppError({
		code: ErrorCode.DI_MISSING_DEPENDENCY,
		message: "Invalid service tag."
	});
	return tag.id;
}
function formatServiceTagLabel(tag) {
	if (!tag || typeof tag !== "object" || typeof tag.description !== "string") return "<invalid-service-tag>";
	return tag.description;
}
//#endregion
export { createDomainToken, createServiceTag, createServiceToken, formatServiceTagLabel, formatTokenLabel, toRuntimeServiceTagKey, toRuntimeTokenKey };

//# sourceMappingURL=tokens.js.map